import React, { ReactNode } from 'react';
import type { DialogProps } from '@radix-ui/react-dialog';

import { cn } from '@/utils/tw_common';
import { Dialog, DialogContent, DialogDescription, DialogTrigger } from '../dialog';
import { Avatar, AvatarFallback, AvatarImage } from '../avatar';



export interface IPayDialogUserInfoProps {
  userInfo: {
    avatar: string;
    userName: string;
    description: string;
  };

}

export const PayDialogUserInfo = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'> & IPayDialogUserInfoProps>(({
  className, userInfo, ...otherProps
}, ref) => {
  return <div className='flex gap-4 items-center leading-[initial]'>
    <div className="flex">
      <div>
        <Avatar className='size-[42px]'>
          {
            userInfo.avatar ? <AvatarImage className='border border-[#e5e5e5] rounded-full' src={userInfo.avatar} /> : <AvatarFallback className="text-white text-[1.3333rem] bg-b_blue_3">{userInfo.userName.charAt(0)}</AvatarFallback>
          }
        </Avatar>
      </div>
    </div>
    <div className="flex flex-col items-start justify-center">
      <div className="text-white text-[1.3333rem] font-semibold">
        {userInfo.userName}
      </div>
      {
        userInfo.description ? <div className="text-white font-normal text-[1.1667rem]">{userInfo.description}</div> : null
      }
    </div>

  </div>;
});

export interface IPayDialogProps extends DialogProps {
  trigger?: ReactNode;
}

export const PayDialog = React.forwardRef<HTMLDivElement, React.PropsWithChildren<React.ComponentProps<'div'> & IPayDialogProps>>(({
  className, children, trigger, ...otherProps
}, ref) => {
  return <Dialog {...otherProps}>
    <DialogTrigger asChild>{trigger}</DialogTrigger>
    <DialogContent className={className}>
      <DialogDescription>{children}</DialogDescription>
    </DialogContent>
  </Dialog>;
});
